var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PICModal_1;
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
import { property, query, queryAssignedElements, state } from 'lit/decorators.js';
import { queryAll } from 'lit/decorators.js';
import { html, css } from 'lit';
import { PIC, PICBase, PICLoadPage, customElement, booleanDecoder, PICGetAns, PICHelp, PICConfig } from '../Internals';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
let PICModal = PICModal_1 = class PICModal extends PICBase {
    constructor() {
        super(...arguments);
        this.title_ = '';
        this.isHidden_ = true;
        this.curChild = null;
        this.selstr = '[piccomponent]:not([disabled], pic-label), input[type="button"]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])';
        this.isResizing = false;
        this.startWidth = 0;
        this.startHeight = 0;
        this.startX = 0;
        this.startY = 0;
        this.windowIsResizing = false;
        this.noChangeOnNavPin = false;
        /** [width, height] in pixels */
        this.modifiedSize = undefined;
        /** [left, top] in pixels */
        this.modifiedPosition = undefined;
        this.width = '';
        this.height = '';
        this.allowResize = false;
        this.hideFooter = false;
        this.disableNav = false;
        this.keepSize = false;
        this.chooseBtnFocus_ = false;
        /** when true, and parent is modal, then child is centered on parent */
        this.centerOnParent = false;
        this.hasPadding = true;
        this.closeColor = '';
        this.parentFieldStr = '';
        this.drawHeader = true;
        this.drawFooter = true;
        this.modalBody = html ``;
        this.isDialog = false;
        this.isNew = false;
        this.selectDisabled = false;
        this.preventCloseRender = false;
        this.handleMouseMove = (e) => {
            if (this.isResizing) {
                let newWidth = this.startWidth + (e.clientX - this.startX);
                let newHeight = this.startHeight + (e.clientY - this.startY);
                requestAnimationFrame(() => {
                    this.modalOuterContainer.style.width = `${newWidth}px`;
                    this.modalOuterContainer.style.height = `${newHeight}px`;
                    this.modalOuterContainer.style.setProperty('transform', 'unset');
                });
            }
        };
        this.handleMouseUp = () => {
            this.isResizing = false;
            let BCR = this.modalOuterContainer.getBoundingClientRect();
            this.modifiedSize = [BCR.width, BCR.height];
            this.modalOuterContainer.style.setProperty('max-width', 'unset');
            this.modalOuterContainer.style.setProperty('max-height', 'unset');
            window.removeEventListener('mousemove', this.handleMouseMove);
            window.removeEventListener('mouseup', this.handleMouseUp);
        };
        this.handleKeys = (e) => {
            if (this.isHidden)
                return;
            let key = e.key;
            if (PIC.getInstance.events.topModal === this) {
                if (key === 'Escape') {
                    this.closeModal(true);
                }
            }
        };
    }
    set submitButton(iSubmitBtn) {
        if (!this.sbmtBtn_)
            this.sbmtBtn_ = iSubmitBtn;
    }
    get submitButton() {
        return this.sbmtBtn_;
    }
    get isHidden() {
        return this.isHidden_;
    }
    ;
    set isHidden(isHidden) {
        this.isHidden_ = isHidden;
    }
    ;
    openModal() {
        this.isHidden = false;
        this.requestUpdate();
    }
    closeModal(iconClick, options) {
        var _a, _b;
        PIC.getInstance.events.topModal = null;
        this.isHidden = true;
        if (this.isNew && iconClick) {
            if (this.parent instanceof PICLoadPage) {
                if (this.parent.nextElementSibling && this.parent.nextElementSibling instanceof PICLoadPage) {
                    if (this.parent.selfSessId && this.parent.nextElementSibling.parentSessId && this.parent.selfSessId === this.parent.nextElementSibling.parentSessId) {
                        (_a = this.parent.nextElementSibling.modal) === null || _a === void 0 ? void 0 : _a.closeModal(true);
                    }
                }
                let prev = this.parent.previousElementSibling;
                if (prev instanceof PICLoadPage && prev.selfSessId && prev.selfSessId === this.parent.parentSessId && !prev.modal.isHidden) {
                    PIC.getInstance.events.topModal = prev.modal;
                }
                // This is brute force custom choicebox from settings
                if (this.parent.customChoiceBox) {
                    if (this.parent.lastResult === 'handleLoad' || this.parent.lastResult === 'DOMupdate' || this.parent.lastResult === 'enable/disable' || this.parent.lastResult === 'message' || this.parent.lastResult === 'command') {
                        this.parent.handleSubmit(this.parent.closeEvent, this.parent.customChoiceBox);
                        this.isHidden = false;
                    }
                }
                else if (this.parent.closeEvent && !this.parent.hasError && this.parent.overrideCloseEvent && !(options === null || options === void 0 ? void 0 : options.forceSubmit)) {
                    this.isHidden = false;
                    this.parent.handleSubmit(this.parent.closeEvent, undefined);
                }
                else if (this.parent.closeEvent && !this.parent.hasError) {
                    this.parent.handleSubmit(this.parent.closeEvent, undefined);
                }
                else {
                    this.parent.handleModalClose(true);
                }
                PIC.getInstance.msg('parent', this.parent);
            }
            if (this.parent instanceof PICGetAns || this.parent instanceof PICHelp || this.parent instanceof PICConfig) {
                this.parent.remove();
            }
        }
        else {
            if (this.curChild) {
                if (this.curChild) {
                    this.curChild.handleModalClose(iconClick);
                }
            }
            if (this.isDialog) {
                let sibling = this.previousElementSibling;
                if (sibling) {
                    if (sibling instanceof PICModal_1 && (sibling.parent instanceof PICLoadPage || sibling.parent instanceof PICGetAns || sibling.parent instanceof PICConfig || sibling.parent instanceof PICHelp)) {
                        PIC.getInstance.events.topModal = sibling;
                    }
                    else {
                        let oldParent = (_b = sibling === null || sibling === void 0 ? void 0 : sibling.parentNode) === null || _b === void 0 ? void 0 : _b.host;
                        if (oldParent instanceof PICLoadPage) {
                            let oldGrandParent = oldParent.parentElement;
                            if (oldGrandParent instanceof PICModal_1)
                                PIC.getInstance.events.topModal = oldGrandParent;
                        }
                    }
                    this.remove();
                    this.requestUpdate();
                }
            }
        }
        window.dispatchEvent(new CustomEvent('ModalClosed'));
        this.requestUpdate();
        let totalModals = PIC.getInstance.findElementsByTagDeep('PIC-MODAL');
        let shouldEnable = true;
        let openModals = [];
        if (totalModals.length > 0) {
            totalModals.forEach(modal => {
                if (!modal.isHidden && modal !== this) {
                    if (modal.disableNav)
                        shouldEnable = false;
                    // find outermost open modal
                    if (modal)
                        openModals.push(modal);
                }
            });
            // Set top modal
            if (openModals.length > 0) {
                PIC.getInstance.events.topModal = openModals[openModals.length - 1];
                openModals[openModals.length - 1].requestUpdate();
            }
        }
        if (this.disableNav && shouldEnable) {
            try {
                let nav = PIC.getInstance.findElementsByTagDeep('PIC-NAVDRAWER')[0];
                nav.dispatchEvent(new CustomEvent('enable', { bubbles: true, cancelable: false }));
            }
            catch (_c) { }
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this.isPicComp_ = false;
        if (!PIC.getInstance.isMobileOrTablet) {
            this.addKeyListener();
        }
        PIC.getInstance.events.topModal = this;
        PIC.getInstance.events.openModals.push(this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (!PIC.getInstance.isMobileOrTablet) {
            this.removeKeyListener();
        }
        if (this.resizeObserver)
            this.resizeObserver.disconnect();
        if (PIC.getInstance.events.openModals.indexOf(this) !== -1) {
            PIC.getInstance.events.openModals.splice(PIC.getInstance.events.openModals.indexOf(this), 1);
        }
    }
    addKeyListener() {
        this.handleKeys.bind(this);
        PIC.getInstance.events.addEventListener('keydown', this.handleKeys);
    }
    removeKeyListener() {
        PIC.getInstance.events.removeEventListener('keydown', this.handleKeys);
    }
    handleSlot() {
        var _a, _b;
        let curSlot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot');
        let aslots = curSlot === null || curSlot === void 0 ? void 0 : curSlot.assignedElements();
        if (aslots) {
            const el = this.shadowRoot.querySelector('h1');
            if (el)
                el.textContent = (_b = aslots[0]) === null || _b === void 0 ? void 0 : _b.title_;
        }
        let loadPage = aslots === null || aslots === void 0 ? void 0 : aslots.find(x => { return x.nodeName == 'PIC-LOADPAGE'; });
        if (loadPage) {
            this.closeColor = 'white';
            loadPage.slotParent = this;
            this.curChild = loadPage;
        }
    }
    updated() {
        var _a, _b, _c, _d;
        if (this.isNew) {
            this.curChild = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.modal-outerContainer');
            if (!this.isHidden) {
                if (this.parent instanceof PICLoadPage && this.parent.nextElementSibling && this.parent.nextElementSibling instanceof PICLoadPage && this.parent.selfSessId === this.parent.nextElementSibling.parentSessId)
                    return;
                if (!PIC.getInstance.events.topModal)
                    PIC.getInstance.events.topModal = this;
            }
        }
        if (this.btns.length > 0 && this.isDialog) {
            if (!this.isHidden) {
                this.btns[this.btns.length - 1].focus();
                this.btns.forEach((btn) => {
                    if (btn.getAttribute('data-focus') === 'true' || btn.getAttribute('data-focus') === 'yes')
                        btn.focus();
                });
                if (!PIC.getInstance.events.topModal)
                    PIC.getInstance.events.topModal = this;
            }
        }
        if (!this.isNew && !this.isDialog) {
            let hasRendered = (_c = (_b = this.querySelector('pic-loadpage')) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.pic-loadpage');
            let close = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('.modal-close');
            if (close && hasRendered)
                close.style.display = 'block';
        }
    }
    positionOnParent() {
        var _a, _b;
        let parentCenter = { x: 0, y: 0 };
        let parentModal;
        let BCR;
        let oldModal = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.modal');
        let prev = (_b = this.parent) === null || _b === void 0 ? void 0 : _b.previousElementSibling;
        if (this.parent instanceof PICLoadPage) {
            if (prev instanceof PICLoadPage && prev.selfSessId === this.parent.parentSessId && !prev.modal.isHidden)
                parentModal = prev.modal;
        }
        if (this.parent instanceof PICGetAns) {
            if (prev instanceof PICLoadPage && !prev.modal.isHidden)
                parentModal = prev.modal;
        }
        if (this.isDialog) {
            let sibling = this.previousElementSibling;
            if (sibling instanceof PICModal_1 && (sibling.parent instanceof PICLoadPage || sibling.parent instanceof PICGetAns || sibling.parent instanceof PICConfig || sibling.parent instanceof PICHelp))
                parentModal = sibling;
            else if (oldModal)
                this.modifiedPosition = [window.innerWidth / 2 - oldModal.clientWidth / 2, window.innerHeight / 2 - oldModal.clientHeight / 2];
        }
        if (parentModal && parentModal.modifiedPosition) {
            BCR = parentModal.modalOuterContainer.getBoundingClientRect();
            parentCenter.x = parentModal.modifiedPosition[0] + (BCR.width / 2);
            parentCenter.y = parentModal.modifiedPosition[1] + (BCR.height / 2);
            if (oldModal)
                this.modifiedPosition = [parentCenter.x - oldModal.clientWidth / 2, parentCenter.y - oldModal.clientHeight / 2];
            else if (this.isNew)
                this.modifiedPosition = [parentCenter.x - (this.modalOuterContainer.clientWidth / 2), parentCenter.y - (this.modalOuterContainer.clientHeight / 2)];
            else
                return false;
            return true;
        }
        return false;
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.resizeObserver = new ResizeObserver((entries) => {
            this.handleModalResize(entries);
        });
        if (this.modalOuterContainer)
            this.resizeObserver.observe(this.modalOuterContainer);
        window.dispatchEvent(new CustomEvent('ModalOpened'));
        if (this.disableNav) {
            try {
                let nav = PIC.getInstance.findElementsByTagDeep('PIC-NAVDRAWER')[0];
                nav.dispatchEvent(new CustomEvent('disable', { bubbles: true, cancelable: false }));
            }
            catch (_a) { }
        }
        let timer = setTimeout(() => {
            var _a, _b;
            let header = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.modal-hdr');
            let infoText = (_b = this.modalOuterContainer) === null || _b === void 0 ? void 0 : _b.querySelector('.infotext');
            if (infoText) {
                let height = window.innerHeight;
                let top = header.getBoundingClientRect().top;
                // make the bottom calculating a bit smaller
                let bottom = height - top - 15;
                infoText.style.setProperty('bottom', bottom + 'px');
                infoText.style.setProperty('left', this.modalOuterContainer.getBoundingClientRect().left + 10 + 'px');
            }
            clearTimeout(timer);
        }, 1);
        // Try to position near parent field if available
        if (this.parentFieldStr && !this.modifiedPosition) {
            let foundField = PIC.getInstance.findElementByIdDeep(this.parentFieldStr);
            if (foundField) {
                this.positionNearLookupField(foundField);
            }
        }
        if (this.isDialog)
            this.positionOnParent();
    }
    positionNearLookupField(field) {
        let lookupBCR = field.getBoundingClientRect();
        let navWidth = PIC.getInstance.userConfig.isNavDrawerPinned ? 250 : 60;
        let left = lookupBCR.left;
        let top = lookupBCR.bottom + 5;
        if ((top + this.modalOuterContainer.clientHeight) > window.innerHeight) {
            top = lookupBCR.top - this.modalOuterContainer.clientHeight - 10;
        }
        if (window.innerWidth < (left + this.modalOuterContainer.clientWidth)) {
            left = window.innerWidth - this.modalOuterContainer.clientWidth;
        }
        if (top < 0)
            top = 0;
        if (left < navWidth)
            left = navWidth;
        this.modifiedPosition = [left, top];
    }
    handleModalResize(entries) {
        entries.forEach(entry => {
            let element = entry.target;
            let BCR = element.getBoundingClientRect();
            let navWidth = PIC.getInstance.userConfig.isNavDrawerPinned ? 250 : 60;
            if (this.isHidden)
                return;
            if (!this.isResizing) { // if not manually resizing
                if (this.parent instanceof PICLoadPage && this.parent.lastResult === 'DOMupdate')
                    return;
                if (this.windowIsResizing) {
                    this.windowIsResizing = false;
                    return;
                }
                if ((this.centerOnParent && this.positionOnParent()) || this.parentFieldStr) {
                    //do nothing
                }
                else
                    this.modifiedPosition = [window.innerWidth / 2 - (BCR.width / 2) + (navWidth / 2), window.innerHeight / 2 - (BCR.height / 2)];
            }
            else { // resizing is done manually
                this.closeChildElements();
                let tableElements = this.parent instanceof PICGetAns ? this.parent.querySelectorAll('pic-webtable') : this.querySelectorAll('pic-webtable');
                tableElements.forEach(table => {
                    if (table.autoFitTable) {
                        table.resetAutoFitHeight();
                        table.handleAutoFit(true);
                    }
                    else
                        table.handleAutoFit();
                });
            }
        });
    }
    handleWindowResize() {
        var _a, _b, _c;
        let navWidth = PIC.getInstance.userConfig.isNavDrawerPinned ? 250 : 60;
        let BCR = (_a = this.modalOuterContainer) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!BCR)
            return;
        this.windowIsResizing = true;
        // setting max values
        let top, left;
        (_b = this.modalOuterContainer) === null || _b === void 0 ? void 0 : _b.style.setProperty('max-width', (window.innerWidth - navWidth) * 0.9 + 'px');
        (_c = this.modalOuterContainer) === null || _c === void 0 ? void 0 : _c.style.setProperty('max-height', (window.innerHeight - 60) * 0.9 + 'px');
        if (BCR.bottom > window.innerHeight)
            top = window.innerHeight - BCR.height;
        if (BCR.right > window.innerWidth)
            left = window.innerWidth - BCR.width;
        if (BCR.top < 0)
            top = 0;
        if (BCR.left < navWidth)
            left = navWidth;
        if (this.modifiedPosition)
            this.modifiedPosition = [left !== null && left !== void 0 ? left : this.modifiedPosition[0], top !== null && top !== void 0 ? top : this.modifiedPosition[1]];
        this.closeChildElements();
    }
    static get styles() {
        const defaultStyle = css `
            :host{
                --pic-modalHdrHeight: 44px;
                --pic-modalOuterContainerHeight: 400px; 
                --pic-modalOuterContainerTop: calc(50%); 
            }
            :host::-webkit-scrollbar,
            :host::-webkit-scrollbar-thumb {
                height: 26px;
                border-radius: 13px;
                background-clip: padding-box;
                border: 10px solid transparent;
            }
           
            :host::-webkit-scrollbar{
                width: 6px;
                height: 6px;
            }
            :host::-webkit-scrollbar-thumb {        
                box-shadow: inset 0 0 0 10px;
                color: var(--pic-scrollbarPassiveColor);
            }
            :host::-webkit-scrollbar-thumb:active,
            :host::-webkit-scrollbar-thumb:hover {
                color: var(--pic-scrollbarActiveColor);
            }
            :host::-webkit-scrollbar-track,
            :host::-webkit-scrollbar-thumb {
                border-radius: 6px;
            }
            :host::-webkit-scrollbar-track {
                background-color: var(--pic-scrollbarTrackColor);
            }
            button:focus {
                    background-color: #275d8c;
                    box-shadow: rgba(0, 0, 0, 0.14) 0px 6px 10px, rgba(0, 0, 0, 0.12) 0px 1px 18px, rgba(0, 0, 0, 0.2) 0px 3px 5px;
                    outline: none;
                    color: var(--pic-onPrimaryHighColor);
                }
            .modal.dialog{
                position: absolute;
                height: auto;
                width: auto;
                top: 50%;
                border-radius: 4px;
                max-height: 60vh;
                padding: 14px;
                margin: 0;
                z-index: 18;
                background-color: white;
            }
            .modal.dialog .container-title{
                max-height: 55vh;
                overflow-y: auto;
            }
            .modal.dialog .modal-close {
                right: 0px !important;
                top: 0px !important;
                position: absolute;
                margin: 10px;
            }
            .modal {
                max-width: 2600px;
                min-width: 20%;
                width: -moz-fit-content;
                width: fit-content;
                /* background-color: white; */
                margin: 5% auto;
                margin-top: calc(var(--headerHeight) + 1rem);
                padding: 20px;
                overflow: hidden;
            }
            .oldModal {                
                position: relative;
                padding: 0px;
                width: 80vw;
                height: 80vh;
                max-width: unset;
                min-width: unset;
                max-height: unset;
                margin-top: calc(var(--headerHeight) + 1rem);
            }
            .oldModal > .modal-close {
                line-height: 16px;
                z-index: 2;
                margin: 10px;
                right: 0;
            }
            .oldModal > .modal-close {
                display: none;
            }
            .modal.dialog > .modal-close {
                display: block;
            }
            .modal::-webkit-scrollbar {
                width: 1rem;
            }
            .oldModal::-webkit-scrollbar {
                width: 6px;
            }
            .oldModal::-webkit-scrollbar-track {
                background-color: var(--headerColor, #ffff);
            }
            .modal-close {
                cursor: pointer;
                color: #aaa;
                float: right;
                font-size: 28px;
                font-weight: bold;
                position: absolute;
                right: 10.5%;
            }
            .modal div {
                font-size: 0.8em;
            }
            .container-title_ {
                border-bottom: 1px solid black;
                -webkit-user-select: none; /* Safari */        
                -moz-user-select: none; /* Firefox */
                -ms-user-select: none; /* IE10+/Edge */
                user-select: none; /* Standard */
                cursor: grab;
            }
            .container-title{
                border-bottom: 1px solid #000;
            }
            h1 {  
                overflow-wrap: normal;
            }
            h1.main {
                font-weight: bold;
            }
            .modal-title {
                font-family: 'Quicksand';
                font-style: normal;
                font-weight: 500;
                font-size: 20px;
                line-height: 22px;
                letter-spacing: 0.15px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: var(--pic-onNavSurfaceColor, rgba(255, 255, 255, 0.87));
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                cursor: grab;
            }
            .modal-title .sub{
                font-family: 'Montserrat';
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 16px;
                letter-spacing: 0.15px;
                height: fit-content;
            }
            .modal-title.dragging{
                cursor: grabbing;
            }
            .container-choice {
                margin-top: 1em;
                display: flex;
                flex-flow: row wrap;
                justify-content: flex-end;
            }
            button {
                margin-left: 1em;
                text-align: center;
                min-width: 4em;
                width: fit-content;
                background: var(--buttonColor, var(--pic-primaryColor, black));
                border: 1px solid var(--buttonColor, var(--pic-primaryColor, black));
                color: white;
                height: 2em;
                border-radius: 7%;
            }
            /* Themed dialog (pic-loadpage customChoiceBox), web3 only. Scoped
               to .web3 rather than :not(.oldModal) because these dialogs go
               through renderOld() regardless of version - see getModalClass().
               Without an explicit color the title inherits the page's
               light-on-dark ink onto a light dialog surface. */
            .modal.dialog.web3 {
                background-color: var(--pic-surfaceColor, white);
                color: var(--pic-onSurfaceHighColor, black);
            }
            .modal.dialog.web3 .container-title {
                border-bottom-color: var(--pic-outline, #000);
            }
            .modal.dialog.web3 button {
                color: var(--pic-onPrimaryHighColor, white);
            }
            .modal.dialog.web3 button:focus {
                /* Primary lightened by a white overlay, so focus tracks the
                   theme instead of the hand-picked navy web2.5 uses. */
                background-color: unset;
                background-image:
                    linear-gradient(var(--pic-whiteOverlayFocusColor), var(--pic-whiteOverlayFocusColor)),
                    linear-gradient(var(--pic-primaryColor), var(--pic-primaryColor));
                color: var(--pic-onPrimaryHighColor);
            }
            .modal-outerContainer.hidden {
                display: none;
            }
            .modal-outerContainer {
                position: absolute;
                width: fit-content;
                height: fit-content;
                max-height: 90vh;
                max-width: calc(100vw - 250px);
                display: flex;
                flex-direction: column;
                background-color: var(--pic-backgroundColor);
                border-radius: 6px;
                overflow: hidden;
                z-index: 18;
                box-sizing: border-box;
                box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);
                visibility: hidden;
            }
            .bodycontainer {
                padding: 14px;
                width: 100%;
            }
            .modal-hdr {
                min-height: var(--pic-modalHdrHeight);
                /* Same surface as the view header and table header - in dark
                   mode this is the muted tone, not the lightened primary. */
                background-color: var(--pic-navSurfaceColor, var(--pic-primaryColor));
                width: 100%;
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
                display: flex;
                justify-content: center;
            }
            .modal-title {
                font-family: 'Quicksand';
                font-style: normal;
                font-weight: 500;
                font-size: 20px;
                line-height: 22px;
                letter-spacing: 0.15px;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .headerContainer {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 0 50px;
            }
           
            .modal-body {
                overflow: auto;
                flex-grow: 1;
            }

            .modal-footer {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                min-height: var(--pic-modalHdrHeight);
                background-color: var(--pic-backgroundColor, white);
                position: sticky;
                bottom: 0;
                overflow-x: auto;
                overflow-y: hidden;
                padding: 0 14px;
                box-sizing: border-box;
                border-bottom-left-radius: 4px;
                border-bottom-right-radius: 4px;
            }
            .modal-footer ::slotted(pic-button) {
                padding-top: 0;
            } 
            .modal-title {
                color: var(--pic-onNavSurfaceColor, rgba(255, 255, 255, 0.87));
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                cursor: grab;
                min-height: var(--pic-modalHdrHeight);
            }
            .modal-title .sub {
                font-family: 'Montserrat';
                font-size: 14px;
                line-height: 14px;
            }
            .modal-title.dragging{
                cursor: grabbing;
            }
            .modal-closeIcon::before {
                font-family: "Material Design Icons";
                font-size: x-large;
                content: '\u{F1398}';
                color: var(--pic-onNavSurfaceColor, #aaa);
                cursor: pointer;
            }
            .modal-closeIcon {
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                right: 0;
                top: 0;
                height: 44px;
                width: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            #mapModal-outerContainer {
                width: auto;
                height: 350px;
                border: 0;
                border-radius: 2.09px;
            }
            .mapModal-closeIcon {
                position: absolute;
                /* z-index: 1; */
                right: 15px;
                top: 15px;
            }
            .mapModal-body {
                position: sticky;
                top: 50px;
            }
            .mapModal-body-slot{
                display: flex;
                justify-content: center;
            }
            .inner-input-default {
                border-color: transparent;
            }
            .modal-drag::before {
                font-family: "Material Design Icons";
                font-size: 28px;
                font-weight: bold;
                content: '\u{F0B90}';
                color: #aaa;
                cursor: pointer;
            }
            .modal-drag {
                cursor: grab;
            }
            .modal-resize::before {
                font-family: "Material Design Icons";
                font-size: 29px;
                content: '\u{F045D}';
                color: #aaa;
                cursor: nwse-resize;
                height: 20px;
                display: flex;
                align-items: flex-end;
                border-bottom-right-radius: 4px;
                transform: translateZ(0)
            }
            .modal-resize {
                clip-path: polygon(100% 0%, 0% 100%, 100% 100%);
                height: fit-content;
                cursor: nwse-resize;
                align-self: flex-end;
                position: absolute;
                right: 0;
                -webkit-user-drag: none;
                user-select: none;
                -moz-user-select: none;
                -webkit-user-select: none;
                -ms-user-select: none;            
            }

            .clickCorner {
                width: 20px;
                height: 20px;
                position: absolute;
                bottom: 0;
                right: 0;
            }
            .fa-solid{
                font-style: normal;
                color: #626364;
            }
            ::slotted([slot="slot-modal-footer"]){
                overflow-x: auto;
                overflow-y: hidden;
                display: flex;
                align-items: center;
                height: 100%;
            }
            .modal-prog-style {
                position: absolute;
                left: 15px;
            }
            .modal-infoIcon::before {
                font-family: "Material Design Icons";
                font-size: x-large;
                content: '\u{F02FD}';
                color: var(--pic-onNavSurfaceColor, rgba(255, 255, 255, 0.87));
                cursor: pointer;
            }
            .infotooltip {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }
            .infotooltip .infotext {
                visibility: hidden;
                background-color: var(--pic-surfaceColor, white);
                color: var(--pic-onSurfaceHighColor, black);
                text-align: center;
                border-radius: 6px;
                padding: 5px;
                transform: scale(0);
                transition: 0.2s ease-in-out;
                transform-origin: bottom left;
                position: fixed;
                z-index: 99;
                align-items:center;
                width: fit-content;
                word-wrap: break-word;
                height: fit-content;
                box-shadow: 0 2px 2px rgba(0, 0, 0, .14), 0 3px 1px rgba(0, 0, 0, .12), 0 1px 5px rgba(0, 0, 0, .2);
                }
            .infotooltip:hover .infotext {
                visibility: visible;
                transform: scale(1);
            }
            .hide-proginfo {
                display: none;
            }
            .overlay {
                z-index: 18;
            }
            .disable-modal {
                position: absolute;
                height: 100%;
                width: 100%;
                background-color: var(--pic-scrimColor, #9b9b9b80);
                z-index: 2;
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    hideOverlay() {
        if (PIC.getInstance.events.topModal && PIC.getInstance.events.topModal !== this) {
            this.requestUpdate();
        }
    }
    handleNavPinning() {
        var _a, _b, _c;
        let BCR = (_a = this.modalOuterContainer) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!BCR)
            BCR = (_c = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.modal')) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
        if (!BCR)
            return;
        if (this.noChangeOnNavPin) {
            this.noChangeOnNavPin = false;
            return;
        }
        if (!this.modifiedPosition)
            return;
        if (!PIC.getInstance.userConfig.isNavDrawerPinned) {
            if (this.modifiedPosition[0] - (250 - 60) >= 60)
                this.modifiedPosition = [this.modifiedPosition[0] - (250 - 60), this.modifiedPosition[1]];
            else
                this.noChangeOnNavPin = true;
        }
        else {
            if (this.modifiedPosition[0] + (250 - 60) + BCR.width <= window.innerWidth)
                this.modifiedPosition = [this.modifiedPosition[0] + (250 - 60), this.modifiedPosition[1]];
            else
                this.noChangeOnNavPin = true;
        }
    }
    getResizeStyle() {
        let styles = [];
        if (this.allowResize === true) {
            styles.push({ 'display': 'flex' });
        }
        else {
            styles.push({ 'display': 'none' });
        }
        if (this.drawFooter === false) {
            styles.push({ 'bottom': '0' });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getBgStyle() {
        var _a, _b, _c, _d, _e, _f;
        let styles = [];
        if (!this.isHidden) {
            let display = 'none';
            styles.push({ 'width': '100%' });
            styles.push({ 'height': '100%' });
            styles.push({ 'background-color': 'var(--pic-scrimColor, #9b9b9b80)' });
            styles.push({ 'position': 'fixed' });
            styles.push({ 'bottom': '0' });
            styles.push({ 'left': '0' });
            if (PIC.getInstance.events.topModal === this)
                display = 'block';
            else if (!this.isNew) { // web 2 modals content is nested within the overlay, so a hidden overlay hides the modal too
                let modalChildren = (_b = (_a = this.curChild) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('pic-modal');
                let topInModalChildren = modalChildren ? Array.from(modalChildren).find(modal => modal === PIC.getInstance.events.topModal) : undefined;
                let topDisplay = ((_f = (_e = (_d = (_c = Array.from(document.querySelectorAll('pic-modal'))) === null || _c === void 0 ? void 0 : _c.find(modal => modal === PIC.getInstance.events.topModal)) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector('.overlay')) === null || _f === void 0 ? void 0 : _f.style.display) === 'block';
                if (topInModalChildren || !topDisplay) {
                    display = 'block';
                }
            }
            styles.push({ 'display': display });
            if (this.isDialog && this.parent instanceof PICHelp)
                styles.push({ 'z-index': '19' });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getContainerStyle() {
        let styles = [];
        if (this.parent instanceof PICHelp) {
            styles.push({ 'z-index': '21' });
        }
        if (this.classList.contains('commInfo'))
            styles.push({ 'z-index': '21' });
        let h = '', w = '';
        if (this.height)
            h = this.height;
        if (this.width)
            w = this.width;
        if (this.allowResize && this.modifiedSize) {
            w = this.modifiedSize[0] + 'px';
            h = this.modifiedSize[1] + 'px';
        }
        if (this.modifiedPosition) {
            styles.push({ 'left': this.modifiedPosition[0] + 'px' });
            styles.push({ 'top': this.modifiedPosition[1] + 'px' });
        }
        if (h)
            styles.push({ 'height': h });
        if (w)
            styles.push({ 'width': w });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getFooterStyle() {
        let styles = [];
        if (this.parent instanceof PICHelp) {
            styles.push({ 'justify-content': 'flex-end' });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getModalClass() {
        return {
            modal: true,
            dialog: this.isDialog,
            oldModal: this.isNew === false,
            //Dialogs (customChoiceBox) render through renderOld() even on web3,
            //so isNew/oldModal can't gate the themed styles - this can.
            web3: PIC.getInstance.webVersion === '3',
        };
    }
    renderOld() {
        const closeStyle = {
            //Inline, so the .modal-close rule can't theme it - web3 gets the
            //themed ink, web2.5 keeps the legacy grey.
            'color': this.closeColor ? this.closeColor
                : PIC.getInstance.webVersion === '3' ? 'var(--pic-onSurfaceMediumColor, #aaa)'
                    : '#aaa',
        };
        return html `
            ${this.renderCSS(true)}
            <div class="overlay" style=${styleMap(this.getBgStyle())}>
                <div class=${classMap(this.getModalClass())} style=${styleMap(this.getContainerStyle())}>
                    ${this.preventCloseRender ? '' : html `<span class="modal-close" style=${styleMap(closeStyle)} @click=${this.closeModal}>&times;</span>`}
                    <slot @slotchange=${this.handleSlot}></slot>
                    ${this.modalBody}
                </div>
            </div>
        `;
    }
    disableSelectHandler(e) {
        e.preventDefault();
    }
    disableSelect(e) {
        if (!this.selectDisabled) {
            this.disableSelectHandler.bind(this);
            PIC.getInstance.addEventListener('selectstart', this.disableSelectHandler);
            this.selectDisabled = true;
        }
    }
    /** Closes any open selectors, suggestions and pickers */
    closeChildElements() {
        let tagstring = 'pic-selector, pic-suggestion, pic-date, pic-dualdate, pic-time';
        let elementsToClose = this.parent instanceof PICGetAns ? this.parent.querySelectorAll(tagstring) : this.querySelectorAll(tagstring);
        if (elementsToClose.length === 0)
            return;
        elementsToClose.forEach((elm) => {
            elm.forceClose();
        });
    }
    handleMouseDown(e) {
        e.preventDefault();
        this.isResizing = true;
        let BCR = this.modalOuterContainer.getBoundingClientRect();
        this.modalOuterContainer.style.setProperty('max-width', window.innerWidth - BCR.left + 'px');
        this.modalOuterContainer.style.setProperty('max-height', window.innerHeight - BCR.top + 'px');
        this.startWidth = BCR.width;
        this.startHeight = BCR.height;
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.closeChildElements();
        window.addEventListener('mousemove', this.handleMouseMove);
        window.addEventListener('mouseup', this.handleMouseUp);
    }
    handleCornerClick(e) {
        e.stopPropagation();
    }
    startDrag(e) {
        if (e.button !== 0)
            return;
        e.preventDefault();
        this.closeChildElements();
        this.header.classList.add('dragging');
        let BCR = this.modalOuterContainer.getBoundingClientRect();
        let infoText = this.modalOuterContainer.querySelector('.infotext');
        let startX = e.clientX - BCR.left;
        let startY = e.clientY - BCR.top;
        let navWidth = PIC.getInstance.userConfig.isNavDrawerPinned ? 250 : 60;
        const dragHandler = (event) => {
            var _a, _b, _c, _d, _e, _f, _g;
            event.preventDefault();
            (_a = this.modalOuterContainer) === null || _a === void 0 ? void 0 : _a.style.setProperty('transform', 'unset');
            let top = event.clientY - startY;
            let left = event.clientX - startX;
            if (top <= 0) // too high
                (_b = this.modalOuterContainer) === null || _b === void 0 ? void 0 : _b.style.setProperty('top', 0 + 'px');
            else if (top >= (window.innerHeight - BCR.height)) // too low
                (_c = this.modalOuterContainer) === null || _c === void 0 ? void 0 : _c.style.setProperty('top', (window.innerHeight - BCR.height) + 'px');
            else // just right
                (_d = this.modalOuterContainer) === null || _d === void 0 ? void 0 : _d.style.setProperty('top', top + 'px');
            if (left <= navWidth) // too far left
                (_e = this.modalOuterContainer) === null || _e === void 0 ? void 0 : _e.style.setProperty('left', navWidth + 'px');
            else if (left >= (window.innerWidth - BCR.width)) // too far right
                (_f = this.modalOuterContainer) === null || _f === void 0 ? void 0 : _f.style.setProperty('left', (window.innerWidth - BCR.width) + 'px');
            else // just right
                (_g = this.modalOuterContainer) === null || _g === void 0 ? void 0 : _g.style.setProperty('left', left + 'px');
            if (this.drawFooter) {
                this.footerContent.style.setProperty('top', top + BCR.top - 44 + 'px');
            }
        };
        const removeDrag = (e) => {
            this.header.classList.remove('dragging');
            let modaldimensions = this.modalOuterContainer.getBoundingClientRect();
            if (e instanceof MouseEvent)
                PIC.getInstance.removeEventListener('mousemove', dragHandler);
            this.modifiedPosition = [modaldimensions.left, modaldimensions.top];
            // prog info positioning
            let infoIcon = this.modalOuterContainer.querySelector('.infotooltip');
            let iconBCR = infoIcon === null || infoIcon === void 0 ? void 0 : infoIcon.getBoundingClientRect();
            if (infoText && iconBCR) {
                infoText.style.setProperty('left', `${iconBCR.left}px`);
                if (modaldimensions.top <= 16) { // too high
                    infoText.style.setProperty('top', `${iconBCR.top + 30}px`);
                    (infoIcon && infoText.style.setProperty('transform-origin', 'top left'));
                }
                else {
                    infoText.style.setProperty('top', `${iconBCR.top - 34}px`);
                    (infoIcon && infoText.style.setProperty('transform-origin', 'bottom left'));
                }
            }
        };
        if (e.type === 'mousedown') {
            PIC.getInstance.addEventListener('mousemove', dragHandler);
            PIC.getInstance.addEventOnce('mouseup', removeDrag);
        }
    }
    getOuterContainerClass() {
        return {
            'modal-outerContainer': true,
            'resize': this.allowResize,
            'hidden': this.isHidden,
        };
    }
    getResizeIconClass() {
        return {
            'modal-resize': this.allowResize,
            'resize': this.allowResize,
        };
    }
    handleFooterSlotChange(e) {
        let timer = setTimeout(() => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            let btns = [];
            btns = Array.from((_b = (_a = this.ftr[0]) === null || _a === void 0 ? void 0 : _a.querySelectorAll('pic-button')) !== null && _b !== void 0 ? _b : []);
            if (btns.length === 0) {
                btns = Array.from((_f = (_e = (_d = (_c = this.ftr[0]) === null || _c === void 0 ? void 0 : _c.querySelector('slot')) === null || _d === void 0 ? void 0 : _d.assignedElements()[0]) === null || _e === void 0 ? void 0 : _e.querySelectorAll('pic-button')) !== null && _f !== void 0 ? _f : []);
            }
            if (btns.length === 0 && ((_g = this.ftr[0]) === null || _g === void 0 ? void 0 : _g.nodeName) === 'PIC-BUTTON') {
                btns = Array.from(this.ftr, elm => elm);
            }
            let bodyElements = Array.from((_h = this.bdy[0]) === null || _h === void 0 ? void 0 : _h.querySelectorAll(this.selstr)).concat(btns);
            this.handleSlottedElmsFirstRender(bodyElements);
            if (btns.length === 0) {
                this.drawFooter = false;
                this.requestUpdate();
            }
            clearTimeout(timer);
        }, 5);
    }
    async waitForFieldReady(fieldId, timeoutMs = 500, pollIntervalMs = 20) {
        const timeoutAt = Date.now() + timeoutMs;
        while (Date.now() < timeoutAt) {
            const fieldRef = PIC.getInstance.picInputs.get(fieldId);
            if (fieldRef) {
                try {
                    await fieldRef.updateComplete;
                }
                catch (error) {
                    PIC.getInstance.msg('PICModal waitForFieldReady updateComplete failed', fieldId, error);
                }
                await new Promise(resolve => requestAnimationFrame(() => resolve()));
                return fieldRef;
            }
            await new Promise(resolve => setTimeout(resolve, pollIntervalMs));
        }
        return null;
    }
    handleSlottedElmsFirstRender(elements) {
        var _a;
        if (elements.length === 0) {
            (_a = this.modalOuterContainer) === null || _a === void 0 ? void 0 : _a.style.setProperty('visibility', 'unset');
            if (!PIC.getInstance.events.topModal)
                PIC.getInstance.events.topModal = this;
            return;
        }
        let fElm = null;
        elements.forEach(async (elm) => {
            var _a, _b, _c, _d;
            const field = await this.waitForFieldReady(elm.id);
            if (field) {
                if (field.focus_ === true)
                    fElm = elm;
            }
            else if (((_a = elm.attributes.getNamedItem('focus')) === null || _a === void 0 ? void 0 : _a.value) === 'true')
                fElm = elm;
            if (elm.nodeName === 'PIC-COLORPICKER') {
                elm.parent = this;
                elm.requestUpdate();
            }
            if (elements.indexOf(elm) === elements.length - 1) {
                (_b = this.modalOuterContainer) === null || _b === void 0 ? void 0 : _b.style.setProperty('visibility', 'unset');
                if (fElm)
                    fElm.focus();
                if (((_d = (_c = this.parent) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('pic-modal')) && PIC.getInstance.events.topModal === this) {
                    if (this.parent instanceof PICLoadPage || this.parent instanceof PICGetAns || this.parent instanceof PICHelp || this.parent instanceof PICConfig) {
                        PIC.getInstance.events.setActiveModalFocusElements(this.parent, elements[0], elm);
                    }
                }
            }
        });
    }
    handleBodySlotChange(e) {
        var _a;
        if (!this.drawFooter) {
            let bodyElements = Array.from((_a = this.bdy[0]) === null || _a === void 0 ? void 0 : _a.querySelectorAll(this.selstr));
            this.handleSlottedElmsFirstRender(bodyElements);
        }
    }
    renderResizeIcon() {
        return html `
            <div class=${classMap(this.getResizeIconClass())} style=${styleMap(this.getResizeStyle())}>
                <div class='clickCorner' @mousedown=${this.handleMouseDown} @click=${((e) => { this.handleCornerClick(e); })}></div>
            </div>
        `;
    }
    renderFooterSlot() {
        return html `
            <footer class='modal-footer' style=${styleMap(this.getFooterStyle())}>
                <slot id="modalFooter" name="slot-modal-footer" @slotchange=${this.handleFooterSlotChange}>
                </slot>
                ${this.allowResize ? this.renderResizeIcon() : ''}
            </footer>  
        `;
    }
    renderNew() {
        return html `
            ${this.renderCSS(true)}
            ${html `<div class="overlay" style=${styleMap(this.getBgStyle())}></div>`}
            <div id='container' class=${classMap(this.getOuterContainerClass())} style=${styleMap(this.getContainerStyle())}>
                <header class='modal-hdr'>
                    <div class='modal-title' @mousedown=${this.startDrag}>
                    ${(this.parent instanceof PICLoadPage) ? this.renderProgInfo() : ''}
                        <div class='headerContainer'>
                            ${unsafeHTML(this.title_)}
                        </div>
                    </div>
                    <div class='modal-closeIcon' @click=${() => { this.closeModal(true); }} ></div>
                </header>
                <div class='modal-body' @scroll=${this.closeChildElements} style="padding: 14px">
                    <slot name="slot-modal-body" class="slot-modal-body" @slotchange=${this.handleBodySlotChange}></slot>
                    <div class="iconholder base-center hidden"></div>
                </div>
                ${this.drawFooter ? this.renderFooterSlot() : ''}
                ${!this.drawFooter && this.allowResize === true ? this.renderResizeIcon() : ''}
            </div>
        `;
    }
    renderProgInfo() {
        var _a;
        // Get the loadpage component and access its apiurl property
        const loadPageComponent = this.parent instanceof PICLoadPage ? this.parent.apiurl : '';
        return html `
        <div class="modal-prog-style ${((_a = PIC.user) === null || _a === void 0 ? void 0 : _a.split('_')[0]) !== 'picit' ? 'hide-proginfo' : ''}" > 
            <div class='modal-infoIcon infotooltip'>
                <span class="infotext pic-caption"><strong>Path: ${loadPageComponent}</strong></span> 
            </div>
        </div> 
        `;
    }
    renderForPicMap() {
        return html `
        ${this.renderCSS(true)}
            ${!(this.parent instanceof PICGetAns) ? html `<div class="overlay" style=${styleMap(this.getBgStyle())}></div>` : ''}
            <div id='container' class=${classMap(this.getOuterContainerClass())} style=${styleMap(this.getContainerStyle())}>
                <header class='modal-hdr'>
                    <div class='modal-title' @mousedown=${this.startDrag}>
                        <div class='headerContainer'>
                            ${unsafeHTML(this.title_)}
                        </div>
                    </div>
                    <div class='modal-closeIcon' @click=${() => { this.closeModal(true); }} ></div>
                </header>
                <div class='modal-body' @scroll=${this.closeChildElements} style="padding: 14px">
                <slot name="slot-modal-body" class="slot-modal-body" @slotchange=${this.handleBodySlotChange}></slot>
                    </div>
                </div>
            </div>
        `;
    }
    render() {
        if (this.drawMode == 'picMap') {
            return this.renderForPicMap();
        }
        else {
            return this.isNew ? this.renderNew() : this.renderOld();
        }
    }
};
__decorate([
    query('.modal-outerContainer')
], PICModal.prototype, "modalOuterContainer", void 0);
__decorate([
    query('.modal-title')
], PICModal.prototype, "header", void 0);
__decorate([
    query('.modal-footer')
], PICModal.prototype, "footerContent", void 0);
__decorate([
    query('.modal-resize')
], PICModal.prototype, "modalResize", void 0);
__decorate([
    queryAssignedElements({ slot: 'slot-modal-header', selector: '*' })
], PICModal.prototype, "hdr", void 0);
__decorate([
    queryAssignedElements({ slot: 'slot-modal-body', selector: '*' })
], PICModal.prototype, "bdy", void 0);
__decorate([
    queryAssignedElements({ slot: 'slot-modal-footer', selector: '*' })
], PICModal.prototype, "ftr", void 0);
__decorate([
    queryAll('.choice-button')
], PICModal.prototype, "btns", void 0);
__decorate([
    state()
], PICModal.prototype, "modifiedSize", void 0);
__decorate([
    state()
], PICModal.prototype, "modifiedPosition", void 0);
__decorate([
    property()
], PICModal.prototype, "width", void 0);
__decorate([
    property()
], PICModal.prototype, "height", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'allowresize' })
], PICModal.prototype, "allowResize", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'hidenfooter' })
], PICModal.prototype, "hideFooter", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'disablenav' })
], PICModal.prototype, "disableNav", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'keepsize' })
], PICModal.prototype, "keepSize", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'chooseBtnFocus' })
], PICModal.prototype, "chooseBtnFocus_", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'centerOnParent' })
], PICModal.prototype, "centerOnParent", void 0);
__decorate([
    property({ type: Boolean })
], PICModal.prototype, "hasPadding", void 0);
__decorate([
    property()
], PICModal.prototype, "closeColor", void 0);
__decorate([
    property()
], PICModal.prototype, "parentFieldStr", void 0);
PICModal = PICModal_1 = __decorate([
    customElement('pic-modal')
], PICModal);
export { PICModal };
//# sourceMappingURL=PICModal.js.map